export enum GtmCommandsEnum {
  config = 'config',
  consent = 'consent',
  event = 'event',
  get = 'get',
  set = 'set',
}

export enum GtmEventsEnum {
  click = 'click',
  exception = 'exception',
  fieldEntry = 'field_entry',
  fullContentLoaded = 'full_content_loaded',
  pageLoad = 'page_load',
  newMessage = 'NewMessage',
  confirmAndScheduleAppointment = 'ConfirmAndScheduleAppointment',
  signUpComplete = 'SignUpComplete',
  signUp = 'SignUp',
  signIn = 'SignIn',
  portalJump = 'PortalJump',
  samlJump = 'SamlJump',
}

export enum GtmClickTypesEnum {
  abandonOnboardingTour = 'abandon_onboardingtour',
  appointmentCancellation = 'appointment_cancellation',
  appointmentsDropdown = 'Appointments_Dropdown',
  commonVisitReason = 'common_visit_reason',
  completedOnboardingtour = 'completed_onboardingtour',
  exitSchedulingGoBack = 'ExitScheduling_GoBack',
  exitSchedulingModalClose = 'ExitScheduling_ModalClose',
  firstAttemptAbandon = 'first_attempt_abandon',
  loginNewUserLink = 'Login_NewUser_LinkClick ',
  newAppointmentAvailabilityFilter = 'NewAppointment_AvailabilityFilter',
  newAppointmentCalendarDateSelect = 'NewAppointment_CalendarDateSelect',
  newAppointmentChangeVisitType = 'NewAppointment_ChangeVisitType',
  newAppointmentChooseDifferentTime = 'NewAppointment_ChooseDifferentTime',
  newAppointmentCompleteList = 'NewAppointment_CompleteList',
  newAppointmentConfirmAndSchedule = 'NewAppointment_ConfirmAndSchedule',
  newAppointmentDirections = 'NewAppointment_Directions',
  newAppointmentFamPermissions = 'NewAppointment_FamPermissions',
  newAppointmentFilterTooltip = 'NewAppointment_FilterTooltip',
  newAppointmentHealthCenterFilter = 'NewAppointment_HealthCenterFilter',
  newAppointmentInPerson = 'NewAppointment_InPerson',
  newAppointmentListSelection = 'NewAppointment_ListSelection',
  newAppointmentLocationNetworkFilter = 'NewAppointment_LocationNetworkFilter',
  newAppointmentProviderSearch = 'NewAppointment_ProviderSearch',
  newAppointmentProvidersFilter = 'NewAppointment_ProvidersFilter',
  newAppointmentReasonSearchSelection = 'NewAppointment_ReasonSearchSelection',
  newAppointmentRequestHelp = 'NewAppointment_RequestHelp',
  newAppointmentRequestHelpSubmit = 'NewAppointment_RequestHelpSubmit',
  newAppointmentSearchAvailability = 'NewAppointment_SearchAvailability',
  newAppointmentSearchNextAvailableDay = 'NewAppointment_SearchNextAvailableDay',
  newAppointmentSearchNextAvailableWeek = 'NewAppointment_SearchNextAvailableWeek',
  newAppointmentTimeSelect = 'NewAppointment_TimeSelect',
  newAppointmentVirtual = 'NewAppointment_Virtual',
  newAppointmentWhoDropdown = 'NewAppointment_WhoDropDown',
  newAppointmentWhoSelection = 'NewAppointment_Who_Selection',
  newAppointmentViewProfile = 'NewAppointment_ViewProfile',
  reschedulingConfirmAndSchedule = 'Rescheduling_ConfirmAndSchedule',
  scheduleAppointmentHomePageTile = 'ScheduleAppointment_homepagetile',
  scheduleViewAppointments = 'ScheduleViewAppointments_Dropdown',
  secondAttemptAbandon = 'second_attempt_abandon',
  signUpBasicInfoBack = 'SignUpRYI_BackClick',
  signUpBasicInfoMRTPhone = 'SignUpRYI_MRTPhoneClick',
  signUpBasicInfoNext = 'SignUpRYI_NextClick',
  signUpCompleteMRTPhone = 'SignUpComplete_MRTPhoneClick',
  signUpCredentialsBack = 'SignUpCC_BackClick',
  signUpCredentialsFinish = 'SignUpCC_FinishClick',
  signUpCredentialsMRTPhone = 'SignUpCC_MRTPhoneClick',
  signUpIdentificationConfirmationMRTPhone = 'SignUpVYI_MRTPhoneClick',
  signUpIdentificationConfirmationVerify = 'SignUpVYI_VerifyClick',
  signUpPotentialFinishRegistrationClick = 'SignUpPotentialFinishRegistrationClick',
  signUpPotentialRegisterAs = 'SignUpPotential_RegisterAs',
  startOnboardingTour = 'start_onboardingtour',
  upcomingAppointmentAddToCalendar = 'UpcomingAppointment_AddToCalendar',
  upcomingAppointmentCancel = 'UpcomingAppointment_Cancel',
  upcomingAppointmentDirections = 'UpcomingAppointment_Directions',
  upcomingAppointmentReschedule = 'UpcomingAppointment_Reschedule',
  upcomingAppointmentViewClinicInfo = 'UpcomingAppointment_ViewClinicInfo',
  upcomingAppointmentViewMap = 'UpcomingAppointment_ViewMap',
  videotourOnboarding = 'Videotour_onboarding',
  virtualVisitCheck = 'virtual_visit_check',
  virtualVisitStart = 'virtual_visit_start',
  visitReason = 'visit_reason',
}

export enum GtmFieldEntryTypesEnum {
  newAppointmentPatientNotesEntry = 'NewAppointment_PatientNotesEntry',
  signUpPotentialSSNEntered = 'SignUpPotential_SSNEntered',
  exitSchedulingDetailsEntry = 'ExitScheduling_DetailsEntry',
}

export enum GtmPageLoadedTypesEnum {
  signUpBasicInfo = 'SignUpBasicInfo_PageLoad',
  signUpCredentials = 'SignUpCredentials_PageLoad',
  signUpIdentification = 'SignUpIdentification_PageLoad',
  signUpIdentificationConfirmation = 'SignUpIdentificationConfirmation_PageLoad',
}
